var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediaIcon2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.928,
    height: 51.928,
    viewBox: "0 0 51.928 51.928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4677",
    "data-name": "Group 4677",
    transform: "translate(-1053 -641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "heart",
    d: "M24.812,4.942a6.633,6.633,0,0,0-9.382,0L14.152,6.22,12.874,4.942a6.634,6.634,0,0,0-9.382,9.382L4.77,15.6l9.382,9.382L23.534,15.6l1.278-1.278a6.633,6.633,0,0,0,0-9.382Z",
    transform: "translate(1066.6 652.761)",
    fill: "none",
    stroke: "#ff9ee0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "message-circle",
    d: "M51.928,26.105a22.779,22.779,0,0,1-2.446,10.329A23.1,23.1,0,0,1,28.823,49.21a22.779,22.779,0,0,1-10.329-2.446L3,51.928,8.165,36.434A22.779,22.779,0,0,1,5.718,26.105,23.1,23.1,0,0,1,18.494,5.446,22.779,22.779,0,0,1,28.823,3h1.359A23.051,23.051,0,0,1,51.928,24.746Z",
    transform: "translate(1051.5 639.5)",
    fill: "none",
    stroke: "#ff9ee0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaIcon2);
export default __webpack_public_path__ + "static/media/media_icon2.892513b05facace827adcc5fb679b0ad.svg";
export { ForwardRef as ReactComponent };